/**
 * EventFacts — the strip under the hero.
 *
 * When it starts, when it ends, and how many activities it is made of. The
 * dates lead because they are what decides whether the rest of the page is
 * worth reading.
 *
 * The format cell is an attribute with no text of its own: the sentence for
 * each `activity_mode` (PARALLEL → "Pick one category") lives in
 * eventDetail.css beside the rest of this page's copy.
 */

import React from 'react';

export default function EventFacts({
  startDatetime, endDatetime, numberOfActivities, activityMode, timeZoneLabel,
}) {
  // One zone for both dates — an event does not start in one place and end in
  // another. Rendered inline so the clause stays on the time's own line.
  // <small>, not <span>: this strip's labels are read with `.evb-fact span`,
  // and a zone is a side note on the value rather than another label.
  const zone = timeZoneLabel
    ? <small className="evb-fact__tz">{timeZoneLabel}</small>
    : null;
  return (
    <div className="evb-facts">
      {/* Named for their owner. This strip carries the EVENT's dates; the
          registration window has its own two dates in the rail, and a bare
          "Starts / Ends" beside "Opens / Closes" left a visitor guessing which
          pair they were reading. */}
      <div className="evb-fact"><span>Event starts</span><b>{startDatetime}{zone}</b></div>
      <div className="evb-fact"><span>Event ends</span><b>{endDatetime}{zone}</b></div>
      <div className="evb-fact">
        <span>Number of activities</span><b>{numberOfActivities}</b>
      </div>
      <div className="evb-fact">
        <span>Format</span>
        <b className="evb-mode" data-arcee-mode={activityMode} />
      </div>
    </div>
  );
}
